import { Button, Card, Col, Divider, Form, Modal, Space, Spin, Radio, DatePicker, message, Tag } from 'antd'
import React, { useState } from 'react'
import dayjs from 'dayjs'
import axios from 'axios'
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { handleShowTYPE, handleShowTypeReply } from '../hook/function';
import Search from 'antd/es/input/Search';
import { ADDLETTER, baseUrlAREA, FINDLETTER, HEADERS_BASIC } from '../../../API/apiUrlsGarfe';

function AddLetter({ open, close, loadData }) {

    const [loading, setLoading] = useState(false);
    const [postData, setPostData] = useState();
    const [form] = Form.useForm();

    const handleClose = () => {
        close(false)
    }

    // console.log("postData", postData)

    const onFinish = async () => {

        // console.log("onFinish")

        // const payload = {
        //     // id: datePicker,
        //     // // date: datePicker.format("YYYY-MM-DD"),
        //     // type: selectedContract.value,
        //     // company: userCompany
        // };
        setLoading(true);

        await axios.post(baseUrlAREA + ADDLETTER, postData, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    message.success("บันทึกสำเร็จ")
                    loadData(dayjs())
                    // setTimeout(() => {
                    //     handleClose()
                    // }, 1000);
                }
            })
            .catch((error) => {
                const status = error?.res?.status;
                message.error(`ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const onChangeStatusReply = (e) => {
        setPostData({ ...postData, statusReply: e.target.value })
    }

    const onChangeTypeReply = (e) => {
        setPostData({ ...postData, statusReply: e.target.value })
    }

    const handleInputChange = (e) => {
        const value = e.target.value;
        // ลบ whitespace ทั้งหมด (space, tab, newline) ออกเพื่อเช็คความยาวที่แท้จริง
        const cleanValue = value.replace(/\s/g, '');

        if (cleanValue.length === 13) {
            onSearchDB(cleanValue);
        }
    };

    const handleChangeDateReply = (e) => {
        // console.log("e", e)
        setPostData({ ...postData, dateReply: e })
    };

    const onSearchDB = async (value) => {
        // console.log("value", value)
        setPostData()
        setLoading(true);

        axios.get(baseUrlAREA + `${FINDLETTER}/${value}`, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    console.log("res data", res.data);
                    if (res.data === null) {
                        message.warning(`ไม่พบข้อมูล`);
                    } else {
                        setPostData(res.data)
                        form.setFieldsValue({
                            ...res.data,
                            dateReply: res.data?.dateReply ? dayjs(res.data?.dateReply) : null

                        })
                    }
                }
            })
            .catch((error) => {
                const status = error?.res?.status;
                const serverMsg = error?.res?.postData?.message;
                console.error("API error:", status, serverMsg || error.message);
                message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
                setPostData()
                form.setFieldsValue({
                    statusReply: null,
                    typeReply: null,
                    dateReply: null
                })
            })
            .finally(() => {
                setLoading(false);
            });


        // setTimeout(() => {
        //   setLoading(false);
        // }, 250);
    };


    return (
        <Modal title="เพิ่มจดหมาย(มือ)" open={open} closable={false} footer={[null]} width={"70%"}>
            <Spin spinning={loading} tip="กำลังโหลดข้อมูล..." size="large">
                <Form
                    labelCol={{
                        span: 6,
                    }}
                    wrapperCol={{
                        span: 14,
                    }}
                    form={form}
                    // layout="horizontal"
                    onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                // initialValues={{
                //     memo: null,
                //     suspensionAmount: 0,
                //     investigateAssetsDate: dayjs(),
                // }}
                >
                    <Col span={24} style={{ textAlign: 'end' }}>
                        <Search
                            placeholder="ค้นหาเลข EMS"
                            enterButton
                            onChange={handleInputChange} // เพิ่มตัวนี้เข้าไป
                            // onSearch={onSearchDB}     // ยังคงไว้เผื่อกด Enter หรือคลิกปุ่มแว่นขยาย
                            style={{
                                width: "auto",
                                borderRadius: "8px",
                            }}
                            size="large"
                            maxLength={13}
                        />
                    </Col>
                    <Card style={{ marginTop: 10 }}>
                        {
                            postData ?
                                <>
                                    <Col span={24} style={{ textAlign: "end" }}><Tag color={'cyan'} style={{ fontSize: '16px', padding: '4px 10px' }}><b>{handleShowTypeReply(postData?.typeReply)}</b></Tag></Col>
                                    <Divider orientation={'left'}><b>ข้อมูลลูกค้า</b></Divider>
                                    <Form.Item label="ประเภทสัญญา" style={{ margin: 0 }}>{handleShowTYPE(postData?.contractSchema)}</Form.Item>
                                    <Form.Item label="ชื่อลูกค้า" style={{ margin: 0 }}>
                                        {postData?.customerFullName} {postData?.typeReply === 1 ? `(คนค้ำ${postData?.customerTypeId})` :
                                            postData?.typeReply === 2 && postData?.customerTypeId === 0 ? "(ผู้เช่าซื้อ)" :
                                                postData?.typeReply === 2 && postData?.customerTypeId !== 0 ? `(คนค้ำ${postData?.customerTypeId})` :
                                                    postData?.typeReply === 3 && postData?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                                                        postData?.typeReply === 3 && postData?.customerTypeId !== 0 ? `(คนค้ำ${postData?.customerTypeId})` :
                                                            postData?.typeReply === 4 && postData?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                                                                postData?.typeReply === 4 && postData?.customerTypeId !== 0 ? `(คนค้ำ${postData?.customerTypeId})` :
                                                                    "-"} ({postData?.CONTNO})</Form.Item>
                                    <Form.Item label="ที่อยู่" style={{ margin: 0 }}>{postData?.ADDR} {postData?.zipcode}</Form.Item>
                                    {/* <Form.Item label="เบอร์โทร" style={{ margin: 0 }}>{postData?.customerFullName} คนค้ำที่ ({postData?.contractNo})</Form.Item> */}
                                    <Form.Item label="รอบ" style={{ margin: 0 }}>{dayjs(postData?.roundDate).format("DD-MM-YYYY")}</Form.Item>
                                    <Form.Item label="EMS ไป" style={{ margin: 0 }}>{postData?.parcelNo}</Form.Item>
                                    <Form.Item label="EMS กลับ" style={{ margin: 0 }}>{postData?.parcelNoResponse}</Form.Item>
                                    <Divider orientation={'left'}><b>การจัดเก็บข้อมูล</b></Divider>
                                    <Form.Item label="ประเภทตอบกลับ" name="statusReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภทตอบกลับ !" }]}>
                                        <Radio.Group
                                            onChange={onChangeStatusReply}
                                            options={[
                                                { value: 1, label: 'ตอบกลับ' },
                                                { value: 2, label: 'ตีกลับ' }
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item label="ประเภทจดหมาย" name="typeReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภทจดหมาย !" }]}>
                                        <Radio.Group
                                            onChange={onChangeTypeReply}
                                            options={[
                                                { value: 1, label: 'บอกกล่าว' },
                                                { value: 2, label: 'สิทธิซื้อรถคืน' },
                                                { value: 3, label: 'แจ้งราคาขายรถ' },
                                                { value: 4, label: 'บอกเลิก' },
                                                { value: 6, label: 'สิทธิซื้อรถคืน(พี่นิ๊กกี้)' },
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item label="ประเภทจดหมาย(มือ)" name="typeReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภทจดหมาย !" }]}>
                                        <Radio.Group
                                            onChange={onChangeTypeReply}
                                            options={[
                                                { value: 7, label: 'บอกกล่าว(มือ)' },
                                                { value: 5, label: 'บอกเลิก(มือ)' }
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item label="วันที่จัดเก็บ" name="dateReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภท !" }]}>
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            onChange={handleChangeDateReply}
                                            value={postData.dateReply ? dayjs(postData.dateReply) : null}
                                        />
                                    </Form.Item>
                                </>
                                :
                                <>
                                    <Divider orientation={'left'}><b>ไม่พบข้อมูล กรุณากรอกเลข EMS</b></Divider>
                                </>
                        }
                    </Card>
                    <Divider />
                    <Col span={24} style={{ textAlign: 'end' }}>
                        <Space>
                            <Button
                                type='primary'
                                danger
                                icon={<CloseOutlined />}
                                onClick={handleClose}
                            >
                                ปิด
                            </Button>
                            <Button
                                type='primary'
                                htmlType='submit'
                                icon={<SaveOutlined />}
                                style={{ backgroundColor: 'green' }}
                            >
                                บันทึก
                            </Button>
                        </Space>
                    </Col>
                </Form>
            </Spin>
        </Modal >
    )
}

export default AddLetter